import { cn } from '@/lib/utils';
import { TruncatedText } from './TruncatedText';

interface TruncatedCellProps {
  text: string;
  className?: string;
}

export const TruncatedCell = ({ text, className }: TruncatedCellProps) => {
  return (
    <TruncatedText text={text} className={cn('max-w-[320px]', className)} />
  );
};
